import { render, staticRenderFns } from "./statistical.vue?vue&type=template&id=ed1aefca"
import script from "./statistical.vue?vue&type=script&lang=js"
export * from "./statistical.vue?vue&type=script&lang=js"
import style0 from "./statistical.vue?vue&type=style&index=0&id=ed1aefca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports